const initialState = {
    favorites: [],
    favoritesWithDisplayName: [],
    isAddingFavorite: false,
    isRemovingFavorite: false
}

export default initialState;
